import React, { useState, useEffect } from "react";
import LoaderSimple from "../../../general/loader";
import moment from "moment";
import { useSelector } from "react-redux";
import numeral from "numeral";
import { Select } from "antd";
import Collapsed from "../../../general/collapsed";
import ReconciliationMovementCard from "../../../reconciliation/movementCard";
import { useReconciliation } from "../../../../customHooks/useReconciliation";
import { useIntl, FormattedMessage } from "react-intl";
import { VaporRangeDatePicker } from "../../../vapor";

const Option = Select.Option;

const BankContent = (props) => {
  const {
    selectedMovements,
    setSelectedMovements,
    setSelectedBankAccount,
    selectedBankAccount,
    setSelectedAmount,
    selectedAmount,
    setEditedValue,
    setStartDate,
    setEndDate,
    startDate,
    endDate,
  } = props;

  const reconciliation = useSelector((state) => state.reconciliation);
  const reconciliationMovements = reconciliation?.movements?.list;

  const [collapsed, setCollapsed] = useState(true);
  const [showAllMovements, setShowAllMovements] = useState(false);

  useEffect(() => {
    let total = 0;
    if (selectedMovements) {
      Object.keys(selectedMovements).forEach((valueKey) => {
        total += selectedMovements[valueKey].amount;
      });
      setSelectedAmount(total);
    }
    setEditedValue(total);
  }, [selectedMovements]);

  const reconciliationHook = useReconciliation();

  const filterDateRange = reconciliationHook.filterDateRange;

  const periods = ["today", "lastWeek", "lastMonth"];
  const periodsDate = {
    today: [moment().endOf("day"), moment().startOf("day")],
    lastWeek: [moment().subtract(1, "d"), moment().subtract(7, "d")],
    lastMonth: [moment().subtract(8, "d"), moment().startOf("month")],
  };

  const noData = useIntl().formatMessage({
    id: "reconciliation.movements.nodata",
  });

  const setMovement = (movement) => {
    if (!selectedMovements[movement.id]) {
      setSelectedMovements({ ...selectedMovements, [movement.id]: movement });
    } else {
      let tmpSelectedMovements = { ...selectedMovements };
      delete tmpSelectedMovements[movement.id];
      setSelectedMovements(tmpSelectedMovements);
    }
  };

  const renderSelectedMovements = () => {
    let items = [];
    Object.keys(selectedMovements).map((i) => {
      let selMov = selectedMovements[i];
      return items.push(
        <ReconciliationMovementCard
          className="dbx-reconciliation-movements-list-group-movement"
          movement={selMov}
          // onLinkedToClick={onLinkedToClick}
          selected={selMov.id}
          onCardClick={() => setMovement(selMov)}
          singleReconciliation={true}
        />
      );
    });
    return items;
  };

  const renderOptions = () => {
    let ibans = [];
    reconciliation.movements.list.map((it) => {
      if (ibans.indexOf(it.iban) === -1) {
        ibans.push(it.iban);
      }
      return null;
    });
    let items = [];
    ibans.map((it) => {
      return items.push(<Option value={it}>{`IBAN ${it}`}</Option>);
    });
    return items;
  };
  // {
  //   "id": "11111111-1111-1111-1111-111111111111",
  //   "description": "food payment",
  //   "statementType": "payment",
  //   "amount": 1.5,
  //   "accountId": "account-1",
  //   "timestamp": "2021-03-30T05:23:35.782488771",
  //   "conciliated": false
  // }

  const groupMovements = (movements) => {
    let retList = {};
    movements.forEach((movement) => {
      if (reconciliationHook.filterIban !== "all" && reconciliationHook.filterIban !== movement.iban) {
        return;
      }
      let dateToCheck = new moment(movement?.transactionDate?.split("T")[0], "YYYY-MM-DD");
      periods.forEach((period) => {
        if (dateToCheck <= periodsDate[period][0] && dateToCheck >= periodsDate[period][1]) {
          if (!retList[period]) {
            retList[period] = [];
          }
          retList[period].push(movement);
        }
      });
    });
    return retList;
  };

  const allMovements = () => {
    const allMovementsCards = reconciliationMovements?.map((movement, index) => {
      return (
        <ReconciliationMovementCard
          key={`ReconciliationMovementCard_${index}`}
          className="dbx-reconciliation-movements-list-group-movement"
          movement={movement}
          // onLinkedToClick={onLinkedToClick}
          selected={selectedMovements[movement.id]}
          onCardClick={() => setMovement(movement)}
          singleReconciliation={true}
        />
      );
    });
    return allMovementsCards;
  };

  const renderMovementsTitles = (period) =>
    useIntl().formatMessage({
      id: "reconciliation.movements.titles." + period,
    });

  const renderMovements = () => {
    let sections = [];
    let items = {};
    let items2 = [];
    periods.map((period) => {
      return (items[period] = []);
    });
    if (!reconciliationMovements || reconciliationMovements?.length < 1) {
      return <div className="dbx-reconciliation-movements-list-nodata">{noData}</div>;
    }
    if (!filterDateRange && !showAllMovements) {
      let groupedMovements = groupMovements(reconciliationMovements);
      if (Object.keys(groupedMovements).length === 0) {
        setShowAllMovements(true);
      }
      periods.map((period) => {
        if (groupedMovements[period]) {
          groupedMovements[period].map((movement) => {
            return items[period].push(
              <ReconciliationMovementCard
                className="dbx-reconciliation-movements-list-group-movement"
                movement={movement}
                // onLinkedToClick={onLinkedToClick}
                selected={selectedMovements[movement.id]}
                onCardClick={() => setMovement(movement)}
                singleReconciliation={true}
              />
            );
          });
          sections.push(
            <div className="dbx-reconciliation-movements-list-group">
              <div className="dbx-reconciliation-movements-list-group-title">
                <span>{renderMovementsTitles(period)}</span>
              </div>
              <div className="dbx-reconciliation-movements-list-group-movements">{items[period]}</div>
            </div>
          );
        }
        return null;
      });
    }
    if (filterDateRange && !showAllMovements) {
      reconciliationMovements.map((movement) => {
        return items2.push(
          <ReconciliationMovementCard
            className="dbx-reconciliation-movements-list-group-movement"
            movement={movement}
            // onLinkedToClick={onLinkedToClick}
            selected={selectedMovements[movement.id]}
            onCardClick={() => setMovement(movement)}
            singleReconciliation={true}
          />
        );
      });
      return items2;
    }
    return (
      <>
        {!showAllMovements ? (
          <>
            {sections}
            <div className="linkShowOther" style={{ marginTop: "20px" }} onClick={() => setShowAllMovements(true)}>
              <FormattedMessage id="deadlines.reconciliation.showOtherMovements" />
            </div>
          </>
        ) : (
          <>{allMovements()}</>
        )}
      </>
    );

    // return items;
  };

  return (
    <React.Fragment>
      <div className="dbx-register-drawer-dates">
        <Collapsed
          key={"history"}
          isCollapsed={collapsed}
          onClick={(e) => {
            setCollapsed(!collapsed);
          }}
          title={
            <span>
              <span style={{ marginRight: "270px" }}>{"Movimenti bancari selezionati"}</span>
              <span style={{ color: "#152935" }}>
                Totale: <b>{numeral(Math.abs(selectedAmount)).format("0,0.00")} € </b>
              </span>
            </span>
          }
        >
          {renderSelectedMovements()}
        </Collapsed>
      </div>

      <div className="dbx-register-drawer-filter">
        <div className="dbx-register-drawer-filter-tip">Seleziona uno o più movimenti per associarli a questa scadenza e registrare il pagamento.</div>
        <div style={{ display: "flex", padding: "12px 0", fontWeight: "500" }}>
          <div style={{ width: "59%", marginRight: "20px" }}>Seleziona conto</div>
          <div>Date movimenti</div>
        </div>
        <div style={{ display: "flex" }}>
          <div style={{ minWidth: 375, marginRight: "20px" }}>
            <Select
              getPopupContainer={(trigger) => trigger.parentNode}
              value={selectedBankAccount}
              placeholder={"Filtra per IBAN"}
              onChange={(val) => setSelectedBankAccount(val)}
              onClear={() => setSelectedBankAccount(null)}
              style={{ width: 300 }}
              allowClear
            >
              {renderOptions()}
            </Select>
          </div>
          <div>
            <VaporRangeDatePicker
              onChange={(e) => {
                if (e && e.length !== 0) {
                  setStartDate(e[0]?.format("YYYY-MM-DD"));
                  setEndDate(e[1]?.format("YYYY-MM-DD"));
                }
              }}
              defaultValue={[moment(startDate), moment(endDate)]}
            />
          </div>
        </div>
      </div>
      <div className="dbx-register-drawer-movements-container">
        <div
          className={"dbx-register-drawer-movements" + (reconciliation.movements.status.started ? " isLoading" : "")}
          // style={{
          //   maxHeight: `calc(100vh - ${
          //     470 +
          //       (Object.keys(selectedMovements).length < 5
          //         ? Object.keys(selectedMovements).length
          //         : 5) *
          //         30 /* +
          //       (Object.keys(selectedMovements).length > 0 ? 10 : 0) */
          //   }px)`
          // }}
        >
          {reconciliation.movements.status.started ? <LoaderSimple message={"Caricamento movimenti bancari ..."} /> : renderMovements()}
        </div>
      </div>
    </React.Fragment>
  );
};

export default BankContent;
